import type { JSX } from 'react';

import AccountSetup from './AccountSetup';
import BreatheScreen from './BreatheScreen';
import BundledSimplifiedSignup from './BundledSimplifiedSignup';
import FocusedLandingPage from './FocusedLandingPage';
import Goals from './Goals';
import Ineligible from './Ineligible';
import MobileHandoff from './MobileHandoff';
import PollMultiClick from './polls/PollMultiClick';
import PollSingleClick from './polls/PollSingleClick';
import PollSingleClickUpdated from './polls/PollUpdated';
import PollWithResponse from './polls/PollWithResponse';
import PremiumUpsell from './PremiumUpsell';
import TestimonialScreen from './TestimonialScreen';
import TransitionScreen from './TransitionScreen';
import WelcomeScreen from './WelcomeScreen';

const ScreenMap: Record<string, JSX.Element> = {
	Goals: <Goals />,
	WelcomeScreen: <WelcomeScreen />,
	PollSingleClick: <PollSingleClick />,
	PollSingleClickUpdated: <PollSingleClickUpdated />,
	PollMultiClick: <PollMultiClick />,
	PollWithResponse: <PollWithResponse />,
	TransitionScreen: <TransitionScreen />,
	BreatheScreen: <BreatheScreen />,
	TestimonialScreen: <TestimonialScreen />,
	AccountSetup: <AccountSetup />,
	PremiumUpsell: <PremiumUpsell />,
	MobileHandoff: <MobileHandoff />,
	Ineligible: <Ineligible />,
	SimplifiedSignup: <BundledSimplifiedSignup />,
	FocusedLandingPage: <FocusedLandingPage />,
};

export default ScreenMap;
